/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST
export const getUserBankAccountTable = params => {
  return axios.post(`${base}/user-accounts/list`, params)
}

export const getUserBankAccountById = params => {
  return axios.get(`${base}/user-accounts/${params.id}`, {params})
}

export const delUserBankAccountById = params => {
  return axios.delete(`${base}/user-accounts/${params.id}`, {params})
}
export const getFinCenterDepartmentTableList = params => {
  return axios.post(`${base}/departments/list`, params)
}
export const getFinCenterDepartmentDetail = params => {
  return axios.get(`${base}/departments/${params.id}`, {params})
}

export const getFinCenterOurCompaniesTable = params => {
  return axios.post(`${base}/our_companies/lists`, params)
}
export const getFinCenterOurCompaniesDetail = params => {
  return axios.get(`${base}/our_companies/${params.id}`, {params})
}

export const createUserBankAccount = params => {
  return axios.post(`${base}/user-accounts`, params)
}

export const batchCreateUserBankAccount = params => {
  return axios.post(`${base}/user-accounts/batch/create`, params)
}

export const batchEditUserBankAccount = params => {
  return axios.post(`${base}/user-accounts/batch/edit`, params)
}

export const updateUserBankAccount = params => {
  return axios.put(`${base}/user-accounts/${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/user-bank-account/user-bank-account.api.js